import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { DELIVERY_ZONE_TEXTS } from "../shared/constants";

interface Props {
  open: boolean;
  municipality: string;
  isDeleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteZoneDialog: React.FC<Props> = ({
  open,
  municipality,
  isDeleting,
  onConfirm,
  onCancel,
}) => (
  <Dialog open={open} onClose={onCancel} data-testid="delete-zone-dialog">
    <DialogTitle>{DELIVERY_ZONE_TEXTS.deleteConfirmTitle}</DialogTitle>
    <DialogContent>
      <DialogContentText>
        {DELIVERY_ZONE_TEXTS.deleteConfirmMessage(municipality)}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} disabled={isDeleting}>
        {DELIVERY_ZONE_TEXTS.cancelButton}
      </Button>
      <Button onClick={onConfirm} color="error" variant="contained" disabled={isDeleting}>
        {DELIVERY_ZONE_TEXTS.deleteButton}
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteZoneDialog;
